import { render, staticRenderFns } from "./LandingTemplate.vue?vue&type=template&id=31f910fd&scoped=true&"
import script from "./LandingTemplate.vue?vue&type=script&lang=js&"
export * from "./LandingTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f910fd",
  null
  
)

export default component.exports